module.exports = __webpack_public_path__ + "static/media/star-empty-light.c4504c68.svg";